/**
 * Cpolicymodal Component
 * Policy experience powered by Crisingmodal (matches Ctermsmodal styling)
 */

'use client';

import { Crisingmodal } from '../Crisingmodal';
import { LegalDocumentContent } from '@/components/legal/LegalDocumentContent';
import PRIVACY_POLICY_MARKDOWN from '@/constants/legal/privacy-policy.md';

export interface CpolicymodalProps {
  visible: boolean;
  onClose: () => void;
}

export function Cpolicymodal({ visible, onClose }: CpolicymodalProps) {
  
  return (
    <Crisingmodal dataElScope="Cpolicymodal/Modal" visible={visible} onClose={onClose} onBack={onClose}padding={28}>
      <LegalDocumentContent
        content={PRIVACY_POLICY_MARKDOWN}

      />
    </Crisingmodal>
  );
}
